import Vue from 'vue'

/** */
/**
 * @typedef {('success'|'error'|'warn'|'info')} AlertType
 */
/**
 * @typedef {Object} AlertOptions
 * @property {string} key 重複的 key 將會
 * @property {AlertType} type 類型 ( v-alert 所提供，success|)
 * @property {string} border
 * @property {string} color
 * @property {string} coloredBorder
 * @property {boolean} text
 * @property {string} icon @example 'mdi-xxxx'
 * @property {boolean} dense
 * @property {number} timeout 時間到將自動關閉
 */
// :type="alert.type"
// :border="alert.border"
// :color="alert.color"
// :colored-border="alert['colored-border']"
// :dense="alert.dense"
// :text="alert.text"
// :icon="alert.icon"
// hideCloseBtn
// timeout
// key
/**
 * 搭配該元件 {@link components/alert-group.vue} 顯示
 * @name Vue#$alert
 * @memberof Vue
 * @param {AlertOptions} opts
 */
function $alert (opts = {}) {
  const $bus = Vue.prototype.$bus
  $bus.$emit('show-alert', opts)
}
Vue.prototype.$alert = $alert
